import React from 'react';
import PropTypes from 'prop-types';
import {VoltageDisplay} from '../VoltageDisplay';
import {ButtonControls} from '../ButtonControls';
import {useTranslation} from 'react-i18next';

import './style.scss';

const VOLTAGE_INCREMENT = 10;
const CURRENT_INCREMENT = 0.1;

const TRANSLATION_KEY = {
  SET_VOLTAGE: 'SetVoltage.string',
  VOLTAGE: 'Voltage.string',
  CURRENT: 'Current.string',
};

export function VoltageBlock(props) {
  const {t} = useTranslation();

  const incrementVoltage = () =>
    props.setVoltage(props.voltage + VOLTAGE_INCREMENT);
  const decrementVoltage = () =>
    props.setVoltage(props.voltage - VOLTAGE_INCREMENT);

  const incremnetCurrent = () => {
    const newValue = props.current + CURRENT_INCREMENT;
    props.setCurrent(roundOffValue(newValue));
  };
  const decrementCurrent = () => {
    const newValue = props.current - CURRENT_INCREMENT;
    props.setCurrent(roundOffValue(newValue));
  };
  return (
    <div className={`ps_settings_voltage ${props.className} `}>
      <h5 className='ps_settings_voltage_title'>
        {t(TRANSLATION_KEY.SET_VOLTAGE)}
      </h5>
      <VoltageDisplay
        voltage={props.voltage}
        current={props.current}
        setVoltage={props.setVoltage}
        setCurrent={props.setCurrent}
      />
      <div className='ps_settings_voltage_controlBlock'>
        <ButtonControls
          text={t(TRANSLATION_KEY.VOLTAGE)}
          increment={incrementVoltage}
          decrement={decrementVoltage}
          altText1={`Increase voltage button. Current voltage set to ${props.voltage} voltage. Select to increase the voltage by 10 volts.`}
          altText2={`Decrease voltage button. Current voltage set to ${props.voltage} voltage. Select to decrease the voltage by 10 volts.`}
        />
        <ButtonControls
          text={t(TRANSLATION_KEY.CURRENT)}
          increment={incremnetCurrent}
          decrement={decrementCurrent}
          altText1={`Increase current button. Current current set to ${props.current} current. Select to increase the current by 0.1 amps.`}
          altText2={`Decrease current button. Current current set to ${props.current} current. Select to decrease the current by 0.1 apms.`}
        />
      </div>
    </div>
  );
}

VoltageBlock.propTypes = {
  ...VoltageDisplay.propTypes,
};

VoltageBlock.defaultProps = {};

const roundOffValue = (number) => {
  return Math.round((number + Number.EPSILON) * 10) / 10;
};
